import { render } from "./MatchingMediaModal.vue?vue&type=template&id=1cfcd053&scoped=true"
import script from "./MatchingMediaModal.vue?vue&type=script&lang=js"
export * from "./MatchingMediaModal.vue?vue&type=script&lang=js"

import "./MatchingMediaModal.vue?vue&type=style&index=0&id=1cfcd053&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfcd053"]])

export default __exports__